import { mutator } from 'satcheljs';
import saveSelectedTab from '../actions/saveSelectedTab';
import { getStore } from '../store/store';
import { MailRibbonTabId } from 'owa-ribbon-ids';

mutator(saveSelectedTab, actionMessage => {
    switch (parseInt(actionMessage.tabId)) {
        case MailRibbonTabId.Tab_Home:
            getStore().selectedTab = MailRibbonTabId.Tab_Home;
            break;
        case MailRibbonTabId.Tab_Message:
            getStore().selectedTab = MailRibbonTabId.Tab_Message;
            break;
        case MailRibbonTabId.Tab_View:
            getStore().selectedTab = MailRibbonTabId.Tab_View;
            break;
        case MailRibbonTabId.Tab_Insert:
            getStore().selectedTab = MailRibbonTabId.Tab_Insert;
            break;
        case MailRibbonTabId.Tab_Format:
            getStore().selectedTab = MailRibbonTabId.Tab_Format;
            break;
        default:
            throw new Error(
                'the tab ' +
                    actionMessage.tabId +
                    ' has not been added to the file saveSelectedTabMutator.ts'
            );
    }
});
